var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expand-transition',[(_vm.tabOpens > 0 || _vm.checkMobile)?_c('v-app-bar',{attrs:{"id":"app-bar","color":"primary","dark":"","app":"","flat":"","height":"63"}},[(_vm.checkMobile)?_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.setDrawer(!_vm.drawer)}}}):_vm._e(),_c('tab',{staticClass:"mt-4"})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }